import React from "react";
import { Image } from "nystem-components";

const ViewImageView = ({ model }) => {
  const { className, width, height, filename, alt } = model;

  if (width) return <Image className={className} alt={alt} src={`/image/${width}x${height}/${filename}`} />;
  return <Image className={className} alt={alt} src={`/image/${filename}`} />;
};
export default ViewImageView;
